import { useSelector } from 'react-redux'
import {
    addAdminUser,
    addUser,
    loginViaLink,
    registerMultiple,
} from '../repositories/AuthRepository'
import store from '../store/store'
import { useAuthActions } from '../store/slices/AuthSlice'

const useAuth = () => {
    const {
        handleLoginSuccess,
        handleLoginFailure,
        handleShowTour,
        handleExpireSession,
        handleHasExpired,
        handleImpersonateSuccess,
        handleStopImpersonationSuccess,
        handleSetExpirationCheckTime,
        handleSetExpirationCheckID,
        handleUpdateShowTour,
        handleProfileSuccess,
        handleAuthorize,
        handleLogout: handleLogoutAction,
        handleForgotPassword,
    } = useAuthActions()

    const authenticated = useSelector(state => state.AuthSlice?.authenticated)
    const role = useSelector(state => state.AuthSlice?.role)
    const user = useSelector(state => state.AuthSlice?.user)
    const impersonated = useSelector(state => state.AuthSlice?.impersonated)
    const impersonatedBy = useSelector(state => state.AuthSlice?.impersonatedBy)
    const impersonatedId = useSelector(state => state.AuthSlice?.impersonatedId)
    const errors = useSelector(state => state.AuthSlice?.errors)
    const hasExpired = useSelector(state => state.AuthSlice?.hasExpired)

    const addUsersAndReturnErrors = users =>
        new Promise((resolve, reject) =>
            registerMultiple(users)
                .then(response => {
                    resolve(response.data.usersNotAdded)
                })
                .catch(err => reject(err.response.data.message)),
        )

    const addNewUser = (userInfo, onAdded, onError) => {
        addUser(userInfo)
            .then(onAdded)
            .catch(onError)
    }

    const addNewAdminUser = (adminInfo, onAdded, onError) => {
        return addAdminUser(adminInfo)
            .then(onAdded)
            .catch(onError)
    }

    const handleLoginViaLink = (values, onLoginSuccess, onError) => {
        return loginViaLink(values)
            .then(onLoginSuccess)
            .catch(onError)
    }

    const handleLogout = () => {
        const currentCheckId = store.getState()?.AuthSlice?.expirationCheckId
        return handleLogoutAction(currentCheckId)
    }

    return {
        addUsersAndReturnErrors,
        addNewUser,
        addNewAdminUser,
        handleLoginViaLink,
        handleLoginSuccess,
        handleLoginFailure,
        handleShowTour,
        handleExpireSession,
        handleHasExpired,
        handleImpersonateSuccess,
        handleStopImpersonationSuccess,
        handleProfileSuccess,
        handleSetExpirationCheckTime,
        handleSetExpirationCheckID,
        handleUpdateShowTour,
        handleAuthorize,
        handleLogout,
        handleForgotPassword,
        authenticated,
        role,
        user,
        impersonated,
        impersonatedBy,
        impersonatedId,
        errors: [...errors],
        hasExpired,
    }
}

export default useAuth
